import React from 'react';

const withBlockedBackNavigation = (WrappedComponent) => {
    class WithBlockedBackNavigationView extends React.Component {

        componentDidMount() {
            // put the very same URL to the history stack so that we landed to it in case back button is pressed
            // we are fine not to use router's history here as we do no need to trigger any re-render
            window.history.pushState({}, '', window.location.href);

            window.addEventListener('popstate', this.handlePopState);
            window.addEventListener('keydown', this.handleKeyDown);
        }

        componentWillUnmount() {
            window.removeEventListener('popstate', this.handlePopState);
            window.removeEventListener('keydown', this.handleKeyDown);
        }

        handleKeyDown = (event) => {
            if ((event.altKey || event.metaKey) && event.key === 'ArrowLeft') {
                event.preventDefault(); // Prevent default back navigation
            }
        }

        handlePopState = () => {
            // when back button is pressed, again put the very same URL to the history stack
            window.history.pushState({}, '', window.location.href);
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    }

    return WithBlockedBackNavigationView;
};

export default withBlockedBackNavigation;
